"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "card-liveness-history"
  }, [!_vm.historyList.length ? _c("not-found") : _c("card", {
    staticClass: "card-detail-image biometric-validation-card"
  }, [_c("div", {
    staticClass: "history-validation"
  }, [_c("div", {
    staticClass: "history-validation__summary"
  }, [_c("div", {
    staticClass: "history-validation__eyebrow"
  }, [_vm._v("\n          Histórico da Jornada\n        ")]), _vm._v(" "), _c("div", {
    staticClass: "history-validation__headline"
  }, [_c("div", [_c("h2", [_vm._v(_vm._s(_vm.historySummary.title))]), _vm._v(" "), _c("p", [_vm._v(_vm._s(_vm.historySummary.description))])]), _vm._v(" "), _c("span", {
    class: ["tag", "history-validation__status-chip", _vm.historySummary.tagClass]
  }, [_c("b-icon", {
    attrs: {
      icon: _vm.historySummary.icon,
      size: "is-small"
    }
  }), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.historySummary.tagLabel))])], 1)]), _vm._v(" "), _c("div", {
    staticClass: "history-validation__meta"
  }, [_c("div", {
    staticClass: "history-validation__meta-item"
  }, [_c("b-icon", {
    attrs: {
      icon: "history",
      size: "is-small"
    }
  }), _vm._v(" "), _c("div", [_c("span", [_vm._v("Total de eventos")]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(_vm.historyList.length))])])], 1), _vm._v(" "), _vm.latestHistoryDate ? _c("div", {
    staticClass: "history-validation__meta-item"
  }, [_c("b-icon", {
    attrs: {
      icon: "calendar",
      size: "is-small"
    }
  }), _vm._v(" "), _c("div", [_c("span", [_vm._v("Última atualização")]), _vm._v(" "), _c("strong", [_vm._v(_vm._s(_vm._f("dateCompleteWithMiliseconds")(_vm.latestHistoryDate)))])])], 1) : _vm._e()])]), _vm._v(" "), _c("section", {
    staticClass: "history-validation__section"
  }, [_c("div", {
    staticClass: "history-validation__section-header"
  }, [_c("div", {
    staticClass: "history-validation__section-title"
  }, [_c("b-icon", {
    attrs: {
      icon: "history"
    }
  }), _vm._v(" "), _c("h3", [_vm._v("Linha do tempo")])], 1), _vm._v(" "), _c("p", [_vm._v("Registro cronológico dos principais eventos executados durante o processamento da jornada.")])]), _vm._v(" "), _c("TimeLine", {
    attrs: {
      list: _vm.historyList
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("h2", {
          staticClass: "card-liveness__title"
        }, [_vm._v(_vm._s(_vm.$t("liveproofTransactionLog.".concat(item.log))))]), _vm._v(" "), _c("p", [_vm._v("Data: " + _vm._s(_vm._f("dateCompleteWithMiliseconds")(item.eventDate)))]), _vm._v(" "), item.deviceEntries.length ? _c("div", {
          staticClass: "history-validation__event-details"
        }, [_c("div", {
          staticClass: "history-validation__event-details-title"
        }, [_c("b-icon", {
          attrs: {
            icon: "devices",
            size: "is-small"
          }
        }), _vm._v(" "), _c("strong", [_vm._v("Dados do dispositivo")]), _vm._v(" "), _c("span", [_vm._v(_vm._s(item.deviceEntries.length))])], 1), _vm._v(" "), _c("dl", {
          staticClass: "history-validation__event-details-list"
        }, _vm._l(item.deviceEntries, function (device) {
          return _c("div", {
            key: device.key,
            staticClass: "history-validation__event-detail-item"
          }, [_c("dt", [_vm._v(_vm._s(device.label))]), _vm._v(" "), _c("dd", {
            attrs: {
              title: device.value
            }
          }, [_vm._v(_vm._s(device.value))])]);
        }), 0)]) : _vm._e(), _vm._v(" "), _vm.isAdmin && item.headerEntries.length ? _c("div", {
          staticClass: "history-validation__event-details"
        }, [_c("div", {
          staticClass: "history-validation__event-details-title"
        }, [_c("b-icon", {
          attrs: {
            icon: "code-tags",
            size: "is-small"
          }
        }), _vm._v(" "), _c("strong", [_vm._v("Headers da requisição")]), _vm._v(" "), _c("span", [_vm._v(_vm._s(item.headerEntries.length))])], 1), _vm._v(" "), _c("dl", {
          staticClass: "history-validation__event-details-list"
        }, _vm._l(item.headerEntries, function (header) {
          return _c("div", {
            key: header.key,
            staticClass: "history-validation__event-detail-item"
          }, [_c("dt", [_vm._v(_vm._s(header.key))]), _vm._v(" "), _c("dd", {
            attrs: {
              title: header.value
            }
          }, [_vm._v(_vm._s(header.value))])]);
        }), 0)]) : _vm._e()];
      }
    }])
  })], 1)])])], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;